import { Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';

@Pipe({
  name: 'scDatePipe',
  standalone: true,
})
export class ScDatePipePipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): string {
    let result = '';
    if (value) {
      if (args.includes('date')) {
        result += `${value.slice(0, 4)}/${value.slice(4, 6)}/${value.slice(
          6,
          8
        )}`;
      }
      if (args.includes('time')) {
        result += ` ${value.slice(8, 10)}:${value.slice(10, 12)}`;
      }
    }
    return result.trim();
  }
}
